import { render } from "./CVView.vue?vue&type=template&id=16d32616&scoped=true"
import script from "./CVView.vue?vue&type=script&lang=js"
export * from "./CVView.vue?vue&type=script&lang=js"

import "./CVView.vue?vue&type=style&index=0&id=16d32616&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d32616"]])

export default __exports__